import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00BE8B",
      d: "M22.004 12.002c0 5.524-4.478 10.002-10.002 10.002S2 17.526 2 12.002 6.478 2 12.002 2s10.002 4.478 10.002 10.002"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "m5.789 12.95 3.542 3.745a.945.945 0 0 0 1.391 0l7.49-7.919a1.08 1.08 0 0 0 0-1.47.945.945 0 0 0-1.392 0l-6.789 7.177-2.851-3.005a.945.945 0 0 0-1.391 0 1.08 1.08 0 0 0 0 1.471",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }